import RequestNavController from './nav.request.controller';
import NavRequestTemplate from './nav.request.tpl.html';

export default {
	controller: RequestNavController,
	template: NavRequestTemplate
};
